import billableEventsEditComponent from './billable_events.edit.component';

let billableEventsEditModule = angular.module('billableEventsEdit', [])

    .component('billableEventsEdit', billableEventsEditComponent)

    .name;

export default billableEventsEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/edit/index.js